import { css } from 'styled-components';
import { NARROW } from '@/breakpoints.js';

// The app's small buttons, as in the strip's toolbar, and the accent of its main action, such as
// Compare. Shared, so that a button anywhere else looks the same.

// What every control of the toolbar shares, so that the field and the buttons line up
export const CONTROL_HEIGHT = 28;
// On a phone every control shares one row, so they are smaller than a usual touch target
export const PHONE_CONTROL_HEIGHT = 30;

export const ACCENT = '#f04';

export const controlButton = css`
	box-sizing: border-box;
	height: ${CONTROL_HEIGHT}px;
	padding: 0 0.8em;
	border: 1px solid #ccc;
	border-radius: 0.4em;
	background: #fff;
	color: inherit;
	font: inherit;
	cursor: pointer;
	white-space: nowrap;

	&:disabled {
		opacity: 0.5;
		cursor: default;
	}

	${NARROW} {
		height: ${PHONE_CONTROL_HEIGHT}px;
		padding: 0 0.55em;
		font-size: 13px;
	}
`;

export const accentButton = css`
	border-color: ${ACCENT};
	background: ${ACCENT};
	color: #fff;
`;
